/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _a;
"use strict";
var PropTypes = require("prop-types");
var React = require("react");
var TransitionGroup = require("react-transition-group/TransitionGroup");
var CSSTransition = require("react-transition-group/CSSTransition");
var classnames = require("classnames");
var KeyDown_1 = require("./util/KeyDown");
var OutsideClick_1 = require("./util/OutsideClick");
var tabTrap_1 = require("./util/tabTrap");
var Panel_1 = require("./Panel");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Modal.css'); }
var Icon_1 = require("./Icon");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-modal");
exports.Modal = tabTrap_1.tabTrap()((_a = /** @class */ (function (_super) {
        tslib_1.__extends(Modal, _super);
        function Modal(props) {
            var _this = _super.call(this, props) || this;
            _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
            _this.handleClose = _this.handleClose.bind(_this);
            _this.handleEsc = _this.handleEsc.bind(_this);
            return _this;
        }
        Modal.prototype.getChildContext = function () {
            return {
                requestModalClose: this.props.requestModalClose,
                closable: this.props.closable
            };
        };
        Modal.prototype.handleOutsideClick = function () {
            var closeOnOutsideClick = this.props.closeOnOutsideClick;
            if (closeOnOutsideClick) {
                return this.close();
            }
        };
        Modal.prototype.handleEsc = function () {
            var closeOnEsc = this.props.closeOnEsc;
            if (closeOnEsc) {
                this.close();
            }
        };
        Modal.prototype.handleClose = function (e) {
            e.preventDefault();
            this.close();
        };
        Modal.prototype.close = function () {
            var _a = this.props, closable = _a.closable, requestModalClose = _a.requestModalClose, name = _a.name;
            if (closable && requestModalClose) {
                return requestModalClose(name);
            }
        };
        Modal.prototype.render = function () {
            var _a = this.props, bottom = _a.bottom, children = _a.children, className = _a.className, compact = _a.compact, centeredContent = _a.centeredContent, contentBelow = _a.contentBelow;
            var classNames = classnames(moduleClassName(), className, bottom ? moduleClassName("bottom") : undefined, compact ? moduleClassName("compact") : undefined, centeredContent ? moduleClassName("centeredContent") : undefined);
            var unwrappedModalPanel = (React.createElement(Panel_1.Panel, { className: moduleClassName("panel") },
                React.createElement("div", { className: moduleClassName("card") }, children),
                !!contentBelow && (React.createElement("div", { className: moduleClassName("contentBelow") }, contentBelow))));
            var wrappedModalPanel = (React.createElement("div", { className: moduleClassName("spacingWrapper") },
                React.createElement("div", { className: moduleClassName("topSpacing") }),
                React.createElement(Panel_1.Panel, { className: moduleClassName("panel") },
                    React.createElement("div", { className: moduleClassName("card") }, children),
                    !!contentBelow && (React.createElement("div", { className: moduleClassName("contentBelow") }, contentBelow)))));
            return (React.createElement(KeyDown_1.KeyDown, { keyCodes: [27], onKeyDown: this.handleEsc },
                React.createElement("div", { className: classNames },
                    React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: this.handleOutsideClick }, bottom || compact ? unwrappedModalPanel : wrappedModalPanel))));
        };
        return Modal;
    }(React.Component)),
    _a.propTypes = {
        name: PropTypes.any,
        title: PropTypes.node,
        compact: PropTypes.bool,
        centeredContent: PropTypes.bool,
        className: PropTypes.string,
        closable: PropTypes.bool,
        contentBelow: PropTypes.node,
        bottom: PropTypes.bool,
        closeOnEsc: PropTypes.bool,
        closeOnOutsideClick: PropTypes.bool,
        requestModalClose: PropTypes.func
    },
    _a.defaultProps = {
        closable: true,
        bottom: false,
        closeOnEsc: true,
        closeOnOutsideClick: true
    },
    _a.childContextTypes = {
        requestModalClose: PropTypes.func,
        closable: PropTypes.bool
    },
    _a));
exports.ModalHeader = function ModalHeader(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(Panel_1.PanelHeader, { className: classnames(moduleClassName("header"), className) }, children));
};
exports.ModalContent = function ModalContent(_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(Panel_1.PanelContent, { className: classnames(moduleClassName("content"), className) }, children));
};
exports.ModalFooter = function ModalFooter(_a) {
    var spread = _a.spread, centered = _a.centered, className = _a.className, children = _a.children;
    return (React.createElement(Panel_1.PanelFooter, { className: classnames(moduleClassName("footer"), spread && moduleClassName("footer-isSpread"), centered && moduleClassName("footer-isCentered"), className) }, children));
};
exports.ModalFooter.propTypes = {
    spread: PropTypes.bool,
    centered: PropTypes.bool
};
var ModalCloseButton = /** @class */ (function (_super) {
    tslib_1.__extends(ModalCloseButton, _super);
    function ModalCloseButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalCloseButton.prototype.render = function () {
        var _this = this;
        return (React.createElement("button", { onClick: function (e) {
                e.preventDefault();
                return _this.props.onClick(e);
            }, className: moduleClassName("close") },
            React.createElement(Icon_1.Icon, { type: "close" })));
    };
    ModalCloseButton.propTypes = {
        onClick: PropTypes.func.isRequired
    };
    return ModalCloseButton;
}(React.Component));
exports.ModalCloseButton = ModalCloseButton;
exports.ModalContainer = function ModalContainer(_a) {
    var children = _a.children;
    return (React.createElement(TransitionGroup, { className: classnames("m-modalContainer", !!children && "m-modalContainer-active") }, !!children &&
        React.Children.map(children, function (child, index) {
            if (!child) {
                return null;
            }
            return (React.createElement(CSSTransition, { classNames: moduleClassName(), timeout: 200, mountOnEnter: true, unmountOnExit: true, key: index }, React.cloneElement(child)));
        })));
};